<template>
  <div>
    <el-form label-position="right">
      <title-and-description :field="field" />
      <el-row :gutter="20" type="flex">
        <el-col :span="12">
          <div class="form-group">
            <label
              class="field-title-label text-black-600 !text-xs 2xl:!text-sm font-normal block !mb-1.5"
            >
              Date Stamp
            </label>
            <div class="d-gird-auto-100">
              <div class="form-group">
                <el-radio v-model="field.datestamp" :label="true">Yes</el-radio>
                <el-radio v-model="field.datestamp" :label="false">No</el-radio>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="!field.datestamp">
            <label
              class="field-title-label !text-black-600 !text-xs 2xl:!text-sm !font-normal block !mb-1"
            >
              Value
              <span class="text-red-500">*</span>
            </label>
            <el-date-picker
              class="!w-full"
              v-model="field.value"
              placeholder="Pick a day"
              type="date"
              :format="getFormat()"
            ></el-date-picker>
            <FormError error-key="value" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="30" type="flex">
        <el-col :span="12">
          <div class="form-group">
            <Tag :field="field" />
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import FormError from '@/components/form/FormError';
  import * as moment from 'moment';
  import Tag from './Tag';
  import TitleAndDescription from './TitleAndDescription';
  import { mapGetters } from 'vuex';

  export default {
    components: {
      FormError,
      TitleAndDescription,
      Tag,
    },
    props: ['field'],
    data() {
      return {
        validations: [],
        date: '',
      };
    },
    computed: {
      ...mapGetters('company', ['getCompanySettings']),
      ...mapGetters('auth', ['getDefaultDateFormat']),
    },
    methods: {
      getFormat() {
        return this.getDefaultDateFormat
          ? this.getDefaultDateFormat === 'MMMM DD YYYY'
            ? 'MMMM-dd-yyyy'
            : this.getDefaultDateFormat.replace('YYYY', 'yyyy').replace('DD', 'dd')
          : 'MM-dd-yyyy';
      },
      onSelectDate() {
        this.field.value = moment(this.date).utc().format();
      },
    },
  };
</script>

<style lang="scss" scoped>
  @media (max-width: 767px) {
    .el-date-editor.el-input {
      width: 150px;
    }
  }
</style>
